import React, { Children } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { helpModalIndex } from '../modals/helpModalIndex';


export const SingleResultGrid = ({ children, data }) => {
  const widths = Children.toArray(children).filter(o => o).map(({ props: { width } }) => width);


  const headers = [];

  Children.toArray(children).filter(o => o).forEach((column, index) => {
    const { id } = column.props;

    headers.push((
      <div
        key={id}
        className="haz-grid-column-header"
        role="columnheader"
        style={{
          width: widths[index],
          minWidth: widths[index],
        }}
      >
        <div className="haz-grid-column-title">{column}</div>
      </div>));
  });

  const dataCells = [];

  Children.toArray(children).filter(o => o).forEach((column, index) => {
    const { id, cell, helpModalId } = column.props;
    let columnHeading = 'Column Info';
    if (helpModalIndex[helpModalId] !== undefined) {
      columnHeading = `${helpModalIndex[helpModalId].title}`;
    }
    dataCells.push((
      <div
        key={id}
        className="haz-single-grid-cell"
        role="gridcell"
        aria-label={columnHeading}
        style={{
          width: widths[index],
          minWidth: widths[index],
        }}
      >
        {/* {data.get(id) && cell({ */}
        {cell({
          // id, row: data, value: (data.get(id) !== undefined) ? `${data.get(id)}` : id, index: 0,
          id, row: data, value: data.get(id), index: 0,
        })}
      </div>
    ));
  });

  return (
    <div className="haz-single-grid">
      <div className="haz-single-grid-headers">
        {headers}
      </div>
      <div className="haz-single-grid-data-row">
        {dataCells}
      </div>
    </div>

  );
};

SingleResultGrid.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element, PropTypes.node]).isRequired,
  data: ImmutablePropTypes.map.isRequired,
};
